import { createSelector } from 'reselect'
import { SettingsRootState } from '../root.reducer'


export const namedRequestInProgress = createSelector(
  [
    (state: SettingsRootState) => state.commonStore.requests,
    (state: SettingsRootState, type: string) => type,
  ],
  (state, type) => {
    return state.filter(request => request.type === type && request.inProgress).length > 0
  },
)

export const namedRequestData = createSelector(
  [
    (state: SettingsRootState) => state.commonStore.requests,
    (state: SettingsRootState, type: string) => type,
  ],
  (state, type) => {
    return state.find(request => request.type === type)
  },
)
